export const DiagnosticPackageStatuses = {
  GENERATING: 'generating',
  LINKING: 'awaiting_createUploadLink',
  UPLOADING: 'awaiting_blobStorageUpload',
  DECRYPTING: 'awaitind_decryption',
  COMPLETED: 'completed',
  ERROR: 'error'
};

export const DiagnosticPackageStatusNames = {
  [DiagnosticPackageStatuses.GENERATING]: 'Generating diagnostic package',
  [DiagnosticPackageStatuses.LINKING]: 'Creating upload link',
  [DiagnosticPackageStatuses.UPLOADING]: 'Uploading diagnostic package',
  [DiagnosticPackageStatuses.DECRYPTING]: 'Decrypting diagnostic package',
  [DiagnosticPackageStatuses.COMPLETED]: 'Completed',
  [DiagnosticPackageStatuses.ERROR]: 'Failed'
};
